import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TenantSignupRequestState } from "src/types/tenantSignupRequest.types";

const initialState: TenantSignupRequestState = {
  list: {
    loading: false,
    data: null,
    error: null,
  },
  approve: {
    loading: false,
    data: null,
    error: null,
  },
  reject: {
    loading: false,
    data: null,
    error: null,
  },
  delete: {
    loading: false,
    data: null,
    error: null,
  },
};

const tenantSignupRequestSlice = createSlice({
  name: "tenantSignupRequest",
  initialState,
  reducers: {
    getSignupRequestsListRequest: (
      state,
      action: PayloadAction<{ page: number; limit: number; status?: string; search?: string }>
    ) => {
      state.list.loading = true;
      state.list.data = null;
      state.list.error = null;
    },
    getSignupRequestsListSuccess: (state, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.data = action.payload;
      state.list.error = null;
    },
    getSignupRequestsListError: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.data = null;
      state.list.error = action.payload;
    },

    approveSignupRequestRequest: (state, action: PayloadAction<{ id: string }>) => {
      state.approve.loading = true;
      state.approve.data = null;
      state.approve.error = null;
    },
    approveSignupRequestSuccess: (state, action: PayloadAction<any>) => {
      state.approve.loading = false;
      state.approve.data = action.payload;
      state.approve.error = null;
    },
    approveSignupRequestError: (state, action: PayloadAction<string>) => {
      state.approve.loading = false;
      state.approve.data = null;
      state.approve.error = action.payload;
    },
    resetApproveSignupRequest: (state) => {
      state.approve.loading = false;
      state.approve.data = null;
      state.approve.error = null;
    },

    rejectSignupRequestRequest: (state, action: PayloadAction<{ id: string }>) => {
      state.reject.loading = true;
      state.reject.data = null;
      state.reject.error = null;
    },
    rejectSignupRequestSuccess: (state, action: PayloadAction<any>) => {
      state.reject.loading = false;
      state.reject.data = action.payload;
      state.reject.error = null;
    },
    rejectSignupRequestError: (state, action: PayloadAction<string>) => {
      state.reject.loading = false;
      state.reject.data = null;
      state.reject.error = action.payload;
    },
    resetRejectSignupRequest: (state) => {
      state.reject.loading = false;
      state.reject.data = null;
      state.reject.error = null;
    },

    deleteSignupRequestRequest: (state, action: PayloadAction<{ id: string }>) => {
      state.delete.loading = true;
      state.delete.data = null;
      state.delete.error = null;
    },
    deleteSignupRequestSuccess: (state, action: PayloadAction<any>) => {
      state.delete.loading = false;
      state.delete.data = action.payload;
      state.delete.error = null;
    },
    deleteSignupRequestError: (state, action: PayloadAction<string>) => {
      state.delete.loading = false;
      state.delete.data = null;
      state.delete.error = action.payload;
    },
    resetDeleteSignupRequest: (state) => {
      state.delete.loading = false;
      state.delete.data = null;
      state.delete.error = null;
    },
  },
});

export const {
  getSignupRequestsListRequest,
  getSignupRequestsListSuccess,
  getSignupRequestsListError,

  approveSignupRequestRequest,
  approveSignupRequestSuccess,
  approveSignupRequestError,
  resetApproveSignupRequest,

  rejectSignupRequestRequest,
  rejectSignupRequestSuccess,
  rejectSignupRequestError,
  resetRejectSignupRequest,

  deleteSignupRequestRequest,
  deleteSignupRequestSuccess,
  deleteSignupRequestError,
  resetDeleteSignupRequest,
} = tenantSignupRequestSlice.actions;
export default tenantSignupRequestSlice.reducer;
